import * as React from "react";
import { useTranslation } from "react-i18next";
import { Tenant } from "../../domains/tenant";
import { Link } from "./link";

type Props = {
  tenant: Tenant | null;
};

export const GBizIDLink: React.FC<Props> = ({ tenant }) => {
  const { t } = useTranslation();
  return tenant?.gBizIdSetting?.activated ? (
    <Link
      href={`/gbizid/${tenant.slug}/login${window.location.search}`}
      data-testid="gbizid-tenants-link"
    >
      {`${tenant.name}のサービスに`}
      {`${t(`%%%GビズIDでログインする%%%`)}`}
    </Link>
  ) : (
    <Link
      href={`/gbizid/tenants${window.location.search}`}
      data-testid="gbizid-tenants-link"
    >
      {t(`%%%GビズIDでログインする%%%`)}
    </Link>
  );
};
